import { css } from 'styled-components';

export default css`
  //margin: 10px 10px 0 10px;
`;
